import React from "react";
import Colors from "Constants/Color";
import { Chip } from "@mui/material";

interface StatusBadgeProps {
  status: string;
  bgColor?: string;
  color?: string;
  fontSize?: string;
  padding?: string;
  borderRadius?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  color,
  bgColor,
  fontSize = "11px",
  padding = "2px 8px",
  borderRadius = "4px",
}) => {
  // Function to determine color based on status if color is not provided

  let isOutlined=false;
  let size = "small"
  const isSmall = fontSize === "11px";
  const label = status || "-";
  const borderColor = bgColor || "#000";
  return (
    <Chip
      label={label}
      style={{
        background: isOutlined ? "transparent" : bgColor,
        color: color,
        border: `1.5px solid ${borderColor}`,
        height: isSmall ? "28px" : "32px",
        fontSize: isSmall ? "11px" : "12px",
        padding: isSmall ? "0 10px" : "0 12px",
        borderRadius: "16px",
        fontWeight: 500,
        fontFamily: `"Poppins", sans-serif`,
        textTransform: "capitalize",
        transition: "all 0.2s ease",
        boxShadow: isOutlined ? "none" : "0 1px 2px rgba(0,0,0,0.05)",
      }}
      size={"small"}
      variant={isOutlined ? "outlined" : "filled"}
    />
  );
};

export default StatusBadge;

